import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  SET_ACTIVE_STATE
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'

export default {
  *[FETCH_LIST]({ payload }) {
    const { tenantId, params } = payload
    yield actions.toggleLoading()
    const data = yield call(services.getStaffs, tenantId, params)
    yield put(actions.listFetched({ data }))
    yield actions.toggleLoading()
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('CONFIGURE_DIALOG')
    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SET_ACTIVE_STATE]({ payload }) {
    const { id, isActive } = payload

    const result = yield call(services.setActiveState, id, isActive)
    yield put(actions.updated(id, result))

    message.success('设置完成')
    // setActiveState
  }
}
